import { runAudioStore } from './audioIdb';

const STORE = 'tracks';

export async function saveOfflineTrack(key, { blob, title, mimeType, originalUrl, itemId }) {
  if (!key) throw new Error('Missing offline key');
  if (!blob) throw new Error('Nothing to save');
  const entry = {
    key: String(key),
    blob,
    title: title || 'Untitled',
    mimeType: mimeType || blob.type || 'audio/mpeg',
    originalUrl: originalUrl || '',
    itemId: itemId || null,
    savedAt: Date.now(),
  };
  await runAudioStore(STORE, 'readwrite', (store) => store.put(entry));
  return entry;
}

export async function getOfflineTrack(key) {
  if (!key) return null;
  return runAudioStore(STORE, 'readonly', (store) => {
    const req = store.get(String(key));
    return new Promise((resolve, reject) => {
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => reject(req.error);
    });
  });
}

export async function deleteOfflineTrack(key) {
  if (!key) return;
  await runAudioStore(STORE, 'readwrite', (store) => store.delete(String(key)));
}

export async function listOfflineTracks() {
  return runAudioStore(STORE, 'readonly', (store) => {
    const req = store.getAll();
    return new Promise((resolve, reject) => {
      req.onsuccess = () => {
        const rows = (req.result || []).slice();
        rows.sort((a, b) => (b.savedAt || 0) - (a.savedAt || 0));
        resolve(rows);
      };
      req.onerror = () => reject(req.error);
    });
  });
}

export async function hasOfflineTrack(key) {
  const row = await getOfflineTrack(key);
  return Boolean(row?.blob);
}
